import { Map } from 'immutable';
import { createSelector } from 'reselect';
import { getLanguage, getStateSlice } from './selectors';

function translate(language, label) {
  const labelForLanguage = label.get('info').get(language);
  const name = label.get('name');
  if (!labelForLanguage) {
    throw new Error(
      `No translations available for overview label ${name} with language ${language}`
    );
  }
  return {
    id: name,
    text: labelForLanguage.get('text')
  };
}

const getOverviewLabelsMap = state =>
  getStateSlice(state).get('overviewLabels');

const getMarketOverviewLabelsMap = state =>
  getStateSlice(state).get('marketOverviewLabels');

export const getOverviewLabels = createSelector(
  getOverviewLabelsMap,
  overviewLabelsMap => overviewLabelsMap.toList()
);

export const getMarketOverviewLabels = createSelector(
  getMarketOverviewLabelsMap,
  overviewLabelsMap => overviewLabelsMap.toList()
);

export const getOverviewLabelsTranslated = createSelector(
  getLanguage,
  getOverviewLabels,
  (language, overviewLabels) => {
    return overviewLabels
      .map(label => translate(language, label))
      .reduce((result, label) => result.set(label.id, label.text), Map());
  }
);
